import type { Guide, GuideRecordHint } from '../types';

/**
 * S-26.10-09 — wycena zapytania z zatwierdzeniem ceny przez dział Trade (decyzja użytkownika 26.10.2026:
 * „handlowiec, czyli dział Trade”; makieta CS-07; scenariusz e2e 37). A37Q — zapytanie z wyceną czekającą
 * na zatwierdzenie, A37P — z ceną zatwierdzoną. Nagrywarka tylko otwiera okna.
 */
const AWAITING: GuideRecordHint = {
  description: 'zapytanie z wyceną czekającą na zatwierdzenie — lista z filtrem „Czekają na zatwierdzenie ceny”',
  listPath: '/inquiries',
  listFilter: { awaitingApproval: '1' },
};
const PRICED: GuideRecordHint = {
  description: 'zapytanie „wycenione” — z listy zapytań',
  listPath: '/inquiries',
  listFilter: { status: 'priced' },
};

export const guide: Guide = {
  flagKey: 'inquiryQuotes',
  title: 'Wycena zapytania z zatwierdzeniem ceny przez dział Trade',
  whatItDoes:
    'Przy zapytaniu wycena z liczb, które już mamy: trasa i opłaty drogowe z map (gdy trasy z map są włączone, inaczej szacunek z opisem), historia cen z TMS na relacji jako zakres, koszt własny najbliższego auta, korekta paliwowa klienta, marża i jej pasmo. Cenników nie mamy — wycena SPOT. CS proponuje cenę, dział Trade ją zatwierdza (inna cena tylko z powodem). Oferta to szkic z ceną zatwierdzoną — wysyłasz sam i oznaczasz „Wysłane ręcznie”.',
  audience: ['CS', 'Trade'],
  presentationItems: ['S-26.10-09'],
  steps: [
    {
      route: '/inquiries/:inquiryId/show',
      record: AWAITING,
      target: 'inquiry-quote',
      title: 'Podstawa wyceny i propozycja ceny',
      description:
        'Trasa, reguły cenowe (brak cennika — SPOT), referencje: historia cen z TMS, koszt własny floty, historia klienta. Po prawej cena dla klienta z marżą liczoną na bieżąco; „Zaproponuj cenę” zapisuje wycenę do zatwierdzenia.',
      action: 'Wpisz cenę i sprawdź marżę.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'a37InquiryId' } },
    },
    {
      route: '/inquiries/:inquiryId/show',
      record: AWAITING,
      target: 'cs-wycena-zatwierdz',
      title: 'Zatwierdzenie ceny — dział Trade',
      description:
        'Cenę zatwierdza trader, Team Leader Trade albo administrator. Można zatwierdzić inną cenę — wtedy z powodem (co najmniej 10 znaków). Kto i z jaką rolą zatwierdził, zostaje przy wycenie.',
      action: 'Jako Trade kliknij „Zatwierdź cenę”.',
      mockupTestId: 'cs-wycena-zatwierdz',
      recorder: {
        account: 'trade',
        demo: { kind: 'scenario', key: 'a37InquiryId' },
        actions: [{ kind: 'click', target: 'cs-wycena-zatwierdz' }],
      },
    },
    {
      route: '/inquiries/:inquiryId/show',
      record: PRICED,
      target: 'cs-wycena-oferta',
      title: 'Oferta — szkic, wysyła człowiek',
      description:
        'Szkic oferty z ceną zatwierdzoną netto, miejscami i terminami (czas polski) i korektą paliwową klienta, jeśli jest w kartotece. Kopiuj albo otwórz w poczcie, wyślij sam i oznacz „Wysłane ręcznie”.',
      action: 'Kliknij „Przygotuj ofertę”.',
      mockupTestId: 'cs-wycena-oferta',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'a37PricedInquiryId' },
        actions: [{ kind: 'click', target: 'cs-wycena-oferta' }],
      },
    },
  ],
};
